// @flow

import React from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';

export default function ErrorDialog({
  isOpen,
  onClose,
  status,
  bodyText,
  title = 'Error communicating with server',
}) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title}>
      <div className={Classes.DIALOG_BODY}>
        <p>
          <strong>Status:</strong> {status}
        </p>
        <pre style={{ maxHeight: 240, overflow: 'auto' }}>{bodyText}</pre>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent="primary" onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
